// extracted by mini-css-extract-plugin
export var cartContainer = "_mi-4";
export var gray = "_mi-1";
export var itemContainer = "_mi-2";
export var itemDetails = "_mi-3";
export var strong = "_mi-0";